import React from "react";
import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";
import { Spinner } from "react-bootstrap";
import { formatDateTime } from "../../../utils/dateTimeFormate";

const RegistrationTable = ({
  data = [],
  loading = false,
  currentPage = 1,
  perPage = 10,
  totalItems = 0,
  totalPages = 1,
  onPageChange,
  onViewDetails,
}) => {
  return (
    <div className="card-body">
      <div className="w-100 table-responsive">
        <div id="example_wrapper" className="dataTables_wrapper">
          <table id="example" className="display w-100 dataTable">
            <thead>
              <tr>
                <th style={{ width: "50px" }}>SN</th>
                <th style={{ width: "110px" }}>Reg. No.</th>
                <th>Applicant Name</th>
                <th style={{ width: "60px" }}>Age</th>
                <th>Discipline</th>
                <th className="col-preferred-centre" style={{ minWidth: "300px" }}>
                  Preferred Centre
                </th>
                <th>Contact</th>
                <th>Registration Date</th>
                <th className="text-center" style={{ width: "90px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center py-5">
                    <Spinner animation="border" variant="primary" size="sm" />
                    <span className="ms-2">Loading registrations...</span>
                  </td>
                </tr>
              ) : data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    <td>
                      <strong>{item.registration_no || "NA"}</strong>
                    </td>
                    <td>{item.candidate_name || "NA"}</td>
                    <td>{item.age ?? "NA"}</td>
                    <td>{item.coe_sports_discipline || "NA"}</td>
                    <td className="col-preferred-centre" style={{ minWidth: "300px" }}>
                      {[
                        ...new Set(
                          [
                            item.training_centre_preference_name_1,
                            item.training_centre_preference_name_2,
                          ].filter(Boolean)
                        ),
                      ].join(", ") || "NA"}
                    </td>
                    <td>{item.mobile_number || "NA"}</td>
                    <td>{formatDateTime(item.created_at) || "NA"}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-primary btn-xs"
                        onClick={() => onViewDetails(item)}
                        title="View Details"
                      >
                        <i className="fa fa-eye"></i> View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (

                <tr>
                  <td colSpan="9" className="text-center py-5 text-muted">
                    No registrations found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3 pt-3">
        <div className="text-muted">
          Showing{" "}
          <span>
            {totalItems > 0 ? (currentPage - 1) * perPage + 1 : 0}
          </span>{" "}
          to{" "}
          <span>{Math.min(currentPage * perPage, totalItems)}</span> of{" "}
          <span>{totalItems}</span> entries
        </div>

        {totalPages > 1 && (
          <PaginationComp
            size={totalPages}
            currentpage={currentPage}
            setCurrentPage={onPageChange}
          />
        )}
      </div>
    </div>
  );
};

export default RegistrationTable;
